import React from 'react';
import * as PropTypes from 'prop-types';

const Select = ({
  onChange = () => {},
  options,
  selected = '',
  isSimple = false
}) => {
  return (
    <select
      className={`focus:outline-hidden focus:ring-0 px-2 md:px-5 rounded-md appearance-none cursor-pointer text-xs md:text-sm ${
        isSimple ? 'bg-transparent' : 'py-2 border border-gray-400'
      }`}
      defaultValue={selected}
      onChange={(e) => {
        return onChange(e?.target?.value);
      }}
    >
      {options?.map((option) => {
        return (
          <option key={option?.code} value={option?.code}>
            {option?.name}
          </option>
        );
      })}
    </select>
  );
};

export default Select;

Select.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.instanceOf(Array).isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSimple: PropTypes.bool
};
